// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import store from "./store";
import dialog from "./plugins/dialog.js";
import confirm from "./components/Confirm";
import filters from "./filter";
import stat from "./plugins/plantStat.js";
import dlrCalendar from "dlrcalendar";
import "./static/font/iconfont.css";
import { Calendar, Search, Empty, Popup, List, PullRefresh, NoticeBar, Sticky, Checkbox } from "vant";
import "./environment/lk_api";
import user from "./api/user.js";
import Tools from "./tools/tools.js";
// import VConsole from "vconsole";
// new VConsole();
// console.log('---->entrance.name', window.entrance.name)
// if (window.entrance.name == "WxMini") {
//   const vConsole = new VConsole();
// }

let _vue = null;
Vue.config.productionTip = false;
// 注册filters
Vue.use(NoticeBar);
Vue.use(Sticky);
Vue.use(filters);
Vue.use(dlrCalendar);
Vue.use(confirm);
Vue.use(PullRefresh);
Vue.use(Empty);
Vue.use(Calendar);
Vue.use(Search);
Vue.use(Popup);
Vue.use(List);
Vue.use(Checkbox);

// 注册全局防抖指令 - 支持 immediate 模式，首次点击立即执行，后续点击在冷却期内忽略
Vue.directive('debounce', {
  inserted: function (el, binding) {
    let timer = null;
    const immediate = binding.arg !== 'false'; // 默认 true，可通过 v-debounce:false 关闭
    const wait = (typeof binding.value === 'object' && binding.value.delay) || 1000; // 默认 800ms，可通过 binding.value.delay 设置

    el.addEventListener('click', function (e) {
      // 如果正在冷却期，阻止默认行为并返回
      if (timer) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      const context = this;
      const args = arguments;

      const later = function () {
        timer = null;
        if (!immediate) {
          const handler = typeof binding.value === 'function' ? binding.value : (binding.value.handler || binding.value);
          handler && handler.apply(context, args);
        }
      };

      const callNow = immediate && !timer;
      clearTimeout(timer);
      timer = setTimeout(later, wait);

      if (callNow) {
        // 首次点击立即执行
        const handler = typeof binding.value === 'function' ? binding.value : (binding.value.handler || binding.value);
        if (handler) {
          try {
            handler.apply(context, args);
          } catch (error) {
            console.error('debounce handler error:', error);
          }
        }
      }
    });
  }
});

// 未授权请求的特殊处理
const unauthorizedHandler = function () {
  let isNeedAuth = true;
  if (typeof _vue.$route.meta.auth !== "undefined") {
    isNeedAuth = _vue.$route.meta.auth;
  }
  console.log(_vue.$route.path, isNeedAuth);
  if (isNeedAuth) {
    const query = { returnUrl: _vue.$route.path };
    _vue.$router.replace({ name: "AccountNewLogin", query: query });
    return false;
  }
};
const setLoginByWxMini = async function () {
  let userId = Tools.getQueryString("uid");
  if (!userId) {
    console.log('---->未获取到uid')
    return
  }
  try {
    let res = await user.getMiniLogin({ userId, type: 2 });
    console.log('---->getMiniLogin', res)
    store.dispatch("getUserInfo")
  } catch (error) {
    console.log('getMiniLogin error', error);
  }
};
// 设置全局拦截
Vue.prototype.$http = axios;
axios.interceptors.response.use(
  function (response) {
    if (response.data.returnCode === 401) {
      if (window.entrance.name === 'WxMini') {
        setLoginByWxMini();
        return response;
      } else {
        unauthorizedHandler();
        return null;
      }
    } else {
      return response;
    }
  },
  function (error) {
    if (_vue) {
      console.log("router object", _vue.$route);
      const status = error.response.status;
      if (status === 401) {
        unauthorizedHandler();
      } else if (status >= 400) {
        dialog.toast({ title: "系统错误，请重试" });
      } else {
        console.log(error.response, typeof error.response);
        return Promise.reject(error);
      }
    }
  }
);
/* 路由埋点守卫 */
router.afterEach((to, from) => {
  // 如果是主app取消页面分享按钮的设置
  if (window.entrance.name === "mainapp") {
    window.AHAPP.invokeNative("actionbarinfo", {
      title: "",
      addmenulist: [],
      stablemenulist: [],
      success: function (result) { },
      fail: function (result) {
        // alert(JSON.stringify(result))
        console.log(JSON.stringify(result));
      },
    });
  }
  stat.routerAfterEach(to, from);
});


Vue.filter("formatDate", function (timestamp) {
  if (!timestamp) return "";

  // 如果时间戳单位是毫秒，将其转换为秒
  if (timestamp.toString().length > 10) {
    timestamp = Math.floor(timestamp / 1000);
  }

  const date = new Date(timestamp * 1000); // 乘以 1000 转回毫秒
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}`;
});
Vue.use(stat);

/* eslint-disable no-new */
_vue = window._vue = new Vue({
  el: "#app",
  axios,
  store,
  router,
  template: "<App/>",
  components: { App },
  created: function () {
    this.$store.dispatch("initCity");
    this.$store.dispatch("initBaseInfo");
    this.$store.dispatch("getUserInfo");
  },
});



// WEBPACK FOOTER //
// ./src/main.js